import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Game} from "../Game";
import {GameUtils} from "../utils/GameUtils";
import {FeatureLogoView} from "../components/FeatureLogoView";
import {WaysCounter} from "../components/WaysCounter";
import {gsap} from "gsap";
import {Config} from "../config/Config";
import {Sound} from "../sound/Sound";

export class ForeGroundElements extends PIXI.Container implements StageLayer {
    private _reelSetFlicker: PIXI.spine.Spine;
    private _idleFlickerEffect: PIXI.spine.Spine;
    private _featureLogoContainer: FeatureLogoView;
    private _waysCounter: WaysCounter;

    constructor() {
        super();
        this.init();
        this.hide();
    }

    public playReelSetFlicker() {
        this._reelSetFlicker.visible = true;
        this._reelSetFlicker.state.setAnimation(0, "animation", true);
        Game.soundPlayer.playSound(Sound.BIG_FRAME_ZAP);
    }

    public stopReelSetFlicker() {
        GameUtils.resetSpineItem(this._reelSetFlicker);
        this._reelSetFlicker.visible = false;
    }

    public playAndStopIdleFlicker(duration: number): gsap.core.Timeline {
        this._idleFlickerEffect.visible = true;
        const flickerTl: gsap.core.Timeline = gsap.timeline();
        flickerTl.add(GameUtils.createTimelineForAnimation(this._idleFlickerEffect, 0, "flicker", false), 0);
        flickerTl.add(() => {
            this._idleFlickerEffect.visible = false;
            flickerTl.pause();
            flickerTl.kill();
        }, duration);
        return flickerTl;
    }

    public show(duration: number = 0.2, alpha: number = 1): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.alpha = 0;
            this.visible = true;
        });
        tl.to(this, {alpha: alpha, duration: duration});
        return tl;
    }

    public hide(duration: number = 0.3): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.to(this, {alpha: 0, duration: duration});
        tl.add(() => {
            this.visible = false;
        });
        return tl;
    }

    private init() {
        this._reelSetFlicker = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("glitchEffect"));
        this._reelSetFlicker.position.set(360, 420);
        this._reelSetFlicker.visible = false;

        this._idleFlickerEffect = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("idleFlicker"));
        this._idleFlickerEffect.position.set(385, 360);
        this._idleFlickerEffect.visible = false;

        this._featureLogoContainer = new FeatureLogoView();
        this._waysCounter = new WaysCounter();
        this.addChild(this._waysCounter);

        this.position.set(0, Config.MARGIN_TOP);
        this.addChild(this._featureLogoContainer, this._reelSetFlicker, this._idleFlickerEffect);
    }

    get waysCounter(): WaysCounter {
        return this._waysCounter;
    }

    get featureLogoContainer(): FeatureLogoView {
        return this._featureLogoContainer;
    }
}